export default __webpack_public_path__ + "static/media/What is final Expense Insuranc.cd8f8f7f.mp3";